import CategoryOption from "./CategoryOption";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllCategories } from "../../api/category.api";
import { AuthData } from "../../pages/Authorization/AuthWrapper";
import { MdOutlineAddCircleOutline   } from "react-icons/md";
import { showError } from "../../services/toastServices";

function CategoriesSectionSidebar() {
    const[selectedOption, setSelectedOption] = useState('');
    const[categories, SetCategories] = useState([])
    const defaultOption = useLocation();

    const { user } = AuthData();

    const handleOptionSelection = (to) => {
        setSelectedOption(to)
    }
    useEffect(() => {
        async function loadCategories() {
            if(user.isAuthenticated){
                await getAllCategories(successGetCategories, errorGetCategories);
            }
        }
        async function loadDefaultOption() {
            setSelectedOption(defaultOption.pathname);
            if (defaultOption.pathname === "/"){
                setSelectedOption("/example");
            }
            
        }

        loadDefaultOption();
        loadCategories();
    }, [user])

    const successGetCategories = ((response)=>{
        SetCategories(response.data.items);
    })
    const errorGetCategories = ((error)=>{
        showError('Error al cargar categorías')
    })

    const renderCategories = categories.map((category) => {

        return <div className="">
            <CategoryOption
                key={category.id}
                to={`/category-projects/${category.id}`}
                editTo={`/category/${category.id}`}
                category={category}
                className="mb-3"
                activeClassName="font-bold border-l-4 border-black pl-2"
                handleOptionSelection={handleOptionSelection}
                selected={selectedOption}
            >
                
            </CategoryOption>
        </div>
    })

    const renderLoggedOutUser = (()=>{
        return(
            <div className="text-red-400 font-bold">No ha iniciado sesión.</div>
        )
    })
    const renderAddCategoryButton=(()=>{
        if(user.isAuthenticated){
            return (<a href="/category-add"><MdOutlineAddCircleOutline size={20}/></a>)
        }
    })

    return (
        <div className="sticky top-0 overflow-auto scrollbar-hide flex flex-col items-start">
            <div className="w-full grid grid-cols-5 mt-1">
                <div className="col-start-1 text-black font-bold">Categorías</div>
                <div className="col-start-5">
                    <div className="mt-1">
                        <span className="flex flex-row justify-left">
                            {renderAddCategoryButton()}
                        </span>
                    </div>
                </div>
            </div>

            <div className="grid grid-cols-1 ml-2">
                {user.isAuthenticated ? renderCategories:renderLoggedOutUser()}
            </div>
        </div>
    )
};

export default CategoriesSectionSidebar;